import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import CustomerSheet from "./customerSheet";
import CustomersStore from "../customersStore";
import { Loading } from "../../common/components/loading";
import ImpiantiClienteStore from "../../impianti/ImpiantiClienteStore";
import { InterventiClienteWidget } from "../../interventi/components/interventiClienteWidget";
import AttachmentsManager from "../../attachments/components/attachmentsManager";
import { ImpiantiClienteWidgets } from "../../impianti/components/impiantiCliente";

interface Props extends RouteComponentProps<{ id: string }> {
}
const CustomerShow = (props: Props) => {
    const { match: { params: { id } } } = props;
    const customer = CustomersStore.use(+id);
    const impianti = ImpiantiClienteStore.useForCustomer(+id);
    if (!customer || !impianti) {
        return <Loading />;
    }

    return (
        <div className="card">
            <div className="card-body">
                <div className="row mt-1 d-flex">
                    <div className="col-12 col-md-6">
                        <CustomerSheet
                            customer={customer}
                        />
                    </div>
                    <div className="col-12 col-md-6">
                        <InterventiClienteWidget idCliente={+id} />
                    </div>
                    {id && <div className="col-12 col-md-6">
                        <ImpiantiClienteWidgets
                            idCliente={customer.idCliente}
                        />
                    </div>
                    }
                    {id && <div className="col-12 col-md-6">
                        <div className="card">
                            <div className="card-header bg-secondary"><h3 className="text-white"><i className="fas fa-file me-2" /> Documenti allegati</h3></div>
                            <div className="card-body p-0">
                                <AttachmentsManager
                                    resourceName="customers"
                                    resourceId={id}
                                />
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
    );
}

export default withRouter(CustomerShow);